import {Component, OnDestroy, OnInit} from '@angular/core';
import {Customer, CustomerService} from '../../../../core/modules/auth/services/customer.service';
import {BehaviorSubject, combineLatest, Observable, Subject} from 'rxjs';
import {filter, startWith, switchMap, takeUntil, tap} from 'rxjs/operators';
import {RosterSyncJob} from '../../../roster-sync-job/interfaces/roster-sync-jobs.model';
import {RosterSyncJobsService} from '../../../roster-sync-job/services/roster-sync-jobs.service';
import {ActiveJobProgressService} from '../../services/active-job-progress.service';
import {ActiveJobMeta, ActiveJobStatus} from '../../interfaces/active-job-progress.model';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-active-job-progress',
  templateUrl: './active-job-progress.component.html',
  styleUrls: ['./active-job-progress.component.scss'],
  animations: [
    trigger('slideLeftRight', [
      state('*', style({
        width: '{{width}}',
        transition: '500ms ease-in-out'}),
      {params: {width: '0%'}}),
    ])
  ]
})
export class ActiveJobProgressComponent implements OnInit, OnDestroy {

  jobStatus$: Observable<ActiveJobStatus>;
  activeSyncJob$: Observable<RosterSyncJob>;
  backoffCountdown$: Observable<number>;
  percentComplete$: BehaviorSubject<string> = new BehaviorSubject<string>('0%');
  private customer$: Observable<Customer>;
  private onDestroy$ = new Subject<void>();
  constructor(private customerService: CustomerService,
              public  activeJobProgress: ActiveJobProgressService,
              private rosterService: RosterSyncJobsService,
              private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.backoffCountdown$ = this.activeJobProgress.getBackoffCountdown().pipe(takeUntil(this.onDestroy$));
    this.customer$ = this.customerService.customerSubject.pipe(
      startWith(this.customerService.customer),
      filter((v) => !!v),
      takeUntil(this.onDestroy$)
    );

    this.jobStatus$ = this.customer$.pipe(
      switchMap((customer) => this.activeJobProgress.getActiveJobForCustomer(customer.customerId)),
      tap((status) => this.computePercentComplete_(status)),
      tap((status) => {
        if(status?.toast){
            this.snackBar.open(status.toast.message,
              null, {duration: status.toast.duration || 6000, panelClass: status.toast.panelClass});
        }
      })
    );

    this.activeSyncJob$ = combineLatest(this.customer$, this.jobStatus$).pipe(
      switchMap(([customer, status]) => this.rosterService.getRosterSyncJobForCustomer(customer.customerId, status.id))
    );

  }

  ngOnDestroy(): void {
    this.onDestroy$.next(null);
  }

  cancelActiveJob(): void {
    this.activeJobProgress.cancelActiveJob();
  }

  private computePercentComplete_(status: ActiveJobStatus) {
    if (status && 'progress' in status) {
      this.percentComplete$.next(`${status.progress}%`);
    } else {
      this.percentComplete$.next(null);
    }
  }
}
